// src/components/ServiceModal.js
import React, { useEffect } from 'react';
import './ServiceModal.css';
import heroBackground from '../assets/images/hero-home.png';
import whiteLogo from '../assets/images/branding-vanguard-white-font-no-logo.png';
import vanguardLogo from '../assets/images/branding-vanguard7.png';

const ServiceModal = ({ service, onClose }) => {
  // Close on Escape key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Close on outside click (desktop only)
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        <button className="modal-close" onClick={onClose}>×</button>
        
        {/* First Section - with hero-home.png background */}
        <div className="modal-first-section">
          <div className="modal-first-bg">
            <img src={heroBackground} alt="Background" className="modal-bg-image" />
            <div className="modal-bg-overlay"></div>
          </div>
          
          <div className="modal-first-content">
            {/* Hero Section - 2 columns */}
            <div className="modal-hero-section">
              <div className="modal-hero-left">
                <img src={service.heroImage} alt={service.title} className="modal-hero-image" />
              </div>
              <div className="modal-hero-right">
                <h2 className="modal-hero-title">{service.title}</h2>
                <p className="modal-hero-text">{service.heroText}</p>
              </div>
            </div>

            {/* How Activities Are Done Line */}
            <div className="modal-activities-line">
              <span className="activities-title">How Activities Are Done:</span>
              <span className="activities-line"></span>
            </div>

            {/* How Activities Are Done Content */}
            <div className="modal-activities-content">
              <div className="activities-list">
                <ul>
                  {service.activitiesList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="activities-logo">
                <img src={whiteLogo} alt="Vanguard" />
              </div>
            </div>
          </div>
          
          {/* Inner shadow at bottom */}
          <div className="modal-inner-shadow"></div>
        </div>

        {/* Second Section - White background */}
        <div className="modal-second-section">
          <div className="modal-second-content">
            {/* Organisational Advantages & Defined Process */}
            <div className="modal-advantages-section">
              <h3 className="advantages-title">Organisational Advantages & Defined Process:</h3>
              
              <div className="advantages-content">
                <div className="advantages-left">
                  <div className="advantages-list-block">
                    <h4>Advantages:</h4>
                    <ul>
                      {service.advantagesList.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="process-list-block">
                    <h4>Process:</h4>
                    <p className="process-items">
                      {service.processList.join(' - ')}
                    </p>
                  </div>
                </div>
                <div className="advantages-right">
                  <img src={vanguardLogo} alt="Vanguard" className="advantages-logo" />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <p>PROTECTING, PRESENTING<br />AND ENHANCING YOUR ASSET</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;